/* eslint-disable indent */
import React, {useCallback, useEffect, useState} from 'react';
// import {useTranslation} from 'react-i18next';
import {MainLoader, DataGrid, ConfirmationModalPromise} from '@components';
import {StyledH3, WhiteButton} from '@styled';
import {useDispatch, useSelector} from 'react-redux';
// import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import {sagaActions} from './redux/saga';
import AddReporter from './AddReporter';

const StyledHeadRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .heading {
  }
  .actions {
  }
`;

const RowActions = ({data, onAction}) => {
  return (
    <div>
      <WhiteButton
        onClick={() => onAction('edit', data)}
        style={{margin: '.16em'}}
      >
        <i className="fa fa-edit mr-1" />
        Edit
      </WhiteButton>
      <WhiteButton
        onClick={() => onAction('delete', data)}
        style={{margin: '.16em'}}
      >
        <i className="fa fa-trash mr-1" />
        Delete
      </WhiteButton>
    </div>
  );
};

const ManageReporters = ({entityId}) => {
  // const [t] = useTranslation();
  const dispatch = useDispatch();
  const remoteData = useSelector((state) => state.entity.reporters);
  const isLoading = useSelector((state) => state.entity.reporters.loading);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const [editRow, setEditRow] = useState(null);
  const [showAddEditModal, setShowAddEditModal] = useState(false);

  // const history = useHistory();

  const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 20,
    totalCount: 0,
    sortOn: 'createdOn',
    sortDir: 'DESC',
  });

  useEffect(() => {
    if (
      remoteData.page !== pagination.page ||
      remoteData.pageSize !== pagination.pageSize ||
      remoteData.totalCount !== pagination.totalCount ||
      remoteData.sortOn !== pagination.sortOn ||
      remoteData.sortDir !== pagination.sortDir
    ) {
      setPagination({
        page: remoteData.page,
        pageSize: remoteData.pageSize,
        totalCount: remoteData.totalCount,
        sortOn: remoteData.sortOn,
        sortDir: remoteData.sortDir,
      });
    }
  }, [remoteData]);

  const fetchData = ({
    page = 1,
    pageSize = pagination.pageSize,
    sortOn,
    sortDir,
  }) => {
    dispatch({
      type: sagaActions.FETCH_ENTITY_REPORTERS,
      payload: {
        entityId,
        values: {
          page,
          pageSize,
          sortOn,
          sortDir,
        },
      },
    });
  };

  useEffect(() => {
    if (entityId !== remoteData.entityId) {
      fetchData({page: 1, pageSize: 20, sortOn: 'createdOn', sortBy: 'DESC'});
    }
  }, [entityId, remoteData.entityId]);

  const handleDeleteActivity = (remove) => {
    dispatch({
      type: sagaActions.REMOVE_ENTITY_REPORTER,
      payload: {
        activityId: remove.id,
        values: {},
      },
    });
  };

  const handleRowAction = useCallback(
    (action, row) => {
      switch (action) {
        case 'edit': {
          setEditRow(row);
          setShowAddEditModal(true);
          break;
        }
        case 'delete': {
          ConfirmationModalPromise({
            title: `Are you sure you want to delete this [${row.userId}] reporter?`,
            show: true,
            confirmBtn: 'Yes',
            cancelBtn: 'No',
            headTitle: 'Confirmation!',
          }).then(
            () => {
              handleDeleteActivity(row);
            },
            () => {
              //  do nothing on failure
            }
          );
          break;
        }
        default:
          break;
      }
    },
    [editRow, showAddEditModal]
  );

  const renderRowActions = (colProps) => {
    const {userId} = colProps;
    if (currentUser.UID !== userId) {
      return <RowActions data={colProps} onAction={handleRowAction} />;
    }
    return '-';
  };

  const Columns = React.useMemo(
    () => [
      {
        accessor: 'userId',
        Header: 'Reporter ID',
        className: 'grey-column d-none d-lg-block',
        width: 50,
        tooltip: false,
      },
      {
        accessor: 'firstName',
        Header: 'Reporter',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({row}) =>
          `${row.original.title} ${row.original.firstName} ${row.original.lastName}`,
      },
      {
        accessor: 'email',
        Header: 'Email',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'phone',
        Header: 'Phone',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'status',
        Header: 'Status',
        tooltip: false,
        className: 'd-none d-lg-block',
      },

      {
        accessor: 'createdOn',
        Header: 'Created On',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => (value ? moment(value).fromNow() : ''),
      },
      {
        id: 'actions',
        Header: <div className="d-none d-lg-block">Actions</div>,
        accessor: renderRowActions,
        disableSortBy: true,
        disableFilters: true,
        width: 50,
      },
    ],
    [pagination]
  );

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <div className="mt-3">
        <StyledHeadRow>
          <StyledH3>Reporters</StyledH3>
          <div className="actions">
            <AddReporter />
          </div>
        </StyledHeadRow>
        <DataGrid
          columns={Columns}
          data={remoteData.data}
          onFetchData={fetchData}
          pagination={pagination}
          filtering={false}
          expandEnabled={false}
        />
      </div>
    </>
  );
};

export default ManageReporters;
